import { ERROR_LOG_TYPE_LABELS } from 'data/error-log-constants';
import { ErrorLogTypeType, InteractionType } from 'types/error-log';

export function formatErrorLogType(type: string): string {
  return ERROR_LOG_TYPE_LABELS[type as ErrorLogTypeType] ?? type;
}

export function formatLoggedAt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}

export function formatClockTime(timestamp: number): string {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  const millis = String(date.getMilliseconds()).padStart(3, '0');
  return `${date.toLocaleTimeString()}.${millis}`;
}

export function formatByteSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function describeInteraction(interaction: InteractionType): string {
  const { target } = interaction;
  const label =
    target.text ?? target.ariaLabel ?? target.name ?? target.id ?? target.tag;
  const action =
    interaction.type === 'keydown'
      ? `Pressed ${interaction.key ?? 'key'} on`
      : 'Clicked';
  return `${action} <${target.tag}> "${label}"`;
}

export function formatErrorLogUser(log: {
  userId: number | null;
  userName: string | null;
  userEmail: string | null;
}): string {
  if (log.userName) {
    return log.userName;
  }
  if (log.userEmail) {
    return log.userEmail;
  }
  if (log.userId !== null) {
    return `User ${log.userId}`;
  }
  return 'Unknown user';
}
